import React from 'react';
import s from './styles.module.css'
import Wrapper from "../../components/wrapper";
import HeaderTitle from "../../components/header_title";

const Conditions = () => {
  return (
    <div className={s.about}>
      <Wrapper>
        <HeaderTitle/>
        <h2>Requisitos básicos</h2>
        <p className={s.text}>Tener residencia.</p>
        <p className={s.text}>Tener una cuenta bancaria a tu nombre.</p>
        <p className={s.text}>Contar con una identificación oficial y una cuenta bancaria.</p>
        <p className={s.text}>Ser mayor de edad.</p>
      </Wrapper>
    </div>
  );
};

export default Conditions;
